import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import leftCornerImage from '../../../../assets/images/leftcorner.png';
import { useMarketAnalysisPosts } from '../../../../hooks/useMarketAnalysisPosts';
import mainImage from '../../../../assets/images/insights/marketanalysis/main/main.jpg';
import mainAvatar from '../../../../assets/images/insights/marketanalysis/main/avatar.png';
import './Main.css';

const ArrowUpRight = () => (
  <svg
    className="market-analysis-main__title-icon"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7 17L17 7M17 7H9M17 7V15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Main = () => {
  const { featuredPost, isLoading } = useMarketAnalysisPosts();

  if (isLoading || !featuredPost) {
    return null;
  }

  const to = `/insights/market-analysis/${featuredPost.slug}`;

  return (
    <section className="market-analysis-main">
      <div className="market-analysis-main__inner">
        <Reveal>
          <Link to={to} className="market-analysis-main__card">
            <img
              className="market-analysis-main__image"
              src={featuredPost.image || mainImage}
              alt=""
            />

            <img
              className="market-analysis-main__corner"
              src={leftCornerImage}
              alt=""
              aria-hidden="true"
            />

            <div className="market-analysis-main__overlay" aria-hidden="true" />

            <div className="market-analysis-main__content">
              <div className="market-analysis-main__copy">
                <p className="market-analysis-main__tag">{featuredPost.category}</p>
                <h2 className="market-analysis-main__title">
                  {featuredPost.title}
                  <ArrowUpRight />
                </h2>
                <p className="market-analysis-main__text">{featuredPost.excerpt}</p>
              </div>

              <div className="market-analysis-main__author">
                <img
                  className="market-analysis-main__avatar"
                  src={featuredPost.avatar || mainAvatar}
                  alt=""
                  aria-hidden="true"
                />
                <div className="market-analysis-main__author-meta">
                  <p className="market-analysis-main__author-name">{featuredPost.author}</p>
                  <p className="market-analysis-main__author-date">{featuredPost.date}</p>
                </div>
              </div>
            </div>
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default Main;
